module.exports = __webpack_public_path__ + "static/media/Asset 10.2@3x.be25a0d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Avatar/Asset 10.2@3x.png
// module id = 2408
// module chunks = 0